import { render, staticRenderFns } from "./industryOverview.vue?vue&type=template&id=b81470c2&scoped=true"
import script from "./industryOverview.vue?vue&type=script&lang=js"
export * from "./industryOverview.vue?vue&type=script&lang=js"
import style0 from "./industryOverview.vue?vue&type=style&index=0&id=b81470c2&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b81470c2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\work\\git-new\\ai-business-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b81470c2')) {
      api.createRecord('b81470c2', component.options)
    } else {
      api.reload('b81470c2', component.options)
    }
    module.hot.accept("./industryOverview.vue?vue&type=template&id=b81470c2&scoped=true", function () {
      api.rerender('b81470c2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/industryChainNew/page/industryOverview.vue"
export default component.exports